import {withNamespaces, WithNamespaces} from 'react-i18next'
import {isMobile} from '../../../commons/selectors/environment'
import {MembersTexts} from '../../../commons/types/members-settings'
import {closeAllEvents, setTab} from '../../actions/events'
import {getUserText} from '../../selectors/component'
import {MemberPageContext, Tabs} from '../../types/state'
import {connect} from '../connect'
import {EventsTabs as EventsTabsPresentation} from './events-tabs'

export interface EventTabsProps extends EventTabsRuntimeProps, WithNamespaces {}

interface EventTabsRuntimeProps {
  setTab: typeof setTab
  tab: Tabs
  pastEventsTabLabel: string
  upcomingEventsTabLabel: string
  mobile: boolean
  rtl: boolean
  closeAllEvents: typeof closeAllEvents
}

const mapRuntime = ({state, actions, isRTL}: MemberPageContext): EventTabsRuntimeProps => ({
  setTab: actions.setTab,
  tab: state.tab,
  pastEventsTabLabel: getUserText(state, MembersTexts.pastEventsTab),
  upcomingEventsTabLabel: getUserText(state, MembersTexts.upcomingEventsTab),
  mobile: isMobile(state),
  rtl: isRTL,
  closeAllEvents: actions.closeAllEvents,
})

export const EventsTabs = connect<{}, EventTabsRuntimeProps>(mapRuntime)(withNamespaces()(EventsTabsPresentation))
